import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button} from '@chakra-ui/react';
  import { Table, TableContainer, Thead, Tbody, Tr, Td, Th} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faFileImport} from "@fortawesome/free-solid-svg-icons";
import Papa from "papaparse";



export default class ListImportModal extends Component 
{
  constructor() {
    super();
    this.state = {
      csvFileName: null,
      parsedResult: null,
      hasImportErrors: false,
      errMsg: "",
      loading: false,
      saving: false
    };

    this.onFileImportRequest = this.onFileImportRequest.bind(this);
    this.onOkButtonClick = this.onOkButtonClick.bind(this);
    this.init = this.init.bind(this);
    this.onCloseRequest = this.onCloseRequest.bind(this);
    
  }

  async componentDidUpdate(prevProps, prevState)
  {
    if (prevProps.show !== this.props.show)
    {
      if (this.props.show)
      {
        await this.init();
      }
    }
  }

  async init()
  {

  }

  onCloseRequest()
  {
    this.setState({csvFileName: "", parsedResult: null, errMsg: "", loading: false, saving: false, hasImportErrors: false});
    this.props.onCloseRequest();
  }


  async onFileImportRequest(event)
  {
    var that = this;
    this.setState({csvFileName: event.target.files[0].name});
    Papa.parse(event.target.files[0], {
        header: true,
        skipEmptyLines: true,
        complete: function (results) 
        {
          var nonEmptyData = results.data.filter(d => d[0] !== "");
          results.data = nonEmptyData;
          var hasImportErrors = ((results.errors) && (results.errors.length > 0));
          that.setState({parsedResult: results, hasImportErrors: hasImportErrors});
        },
      });
  }




  async onOkButtonClick(e) 
  {
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.parsedResult)
    {
      this.setState({errMsg: "Select a file to import."})
      return;
    }
    this.setState({
      errMsg: "",
      saving: true
    });

    try
    {

      var result = [];
      this.state.parsedResult.data.forEach((ln) => 
      {
        var vals = Object.values(ln);
        var dataItem = {
            name: vals[0],
            id: vals[1]
          }
          result.push(dataItem);

      })
      await this.props.onPostRequest(result);
    }
    catch(e)
    {
      var errMsg = "Problem converting file to Data List (" + e.message + ")";
      this.setState({errMsg: errMsg});
    }
    finally 
    {
      this.setState({saving: false});
    }
  }

  render() {
    //console.info(this.props.dataRow);

    const savingDiv = (this.state.saving) ?
    <div><FontAwesomeIcon icon={faSyncAlt} spin={true} color={"green"}/>&nbsp; Saving...</div>
    : "";



    return (

      (this.props.isOpen) ?
      <Modal
        isOpen={this.props.isOpen} 
        onClose={this.props.onCloseRequest}
        scrollBehavior='inside'
      >
        <ModalOverlay/>
        <ModalContent minW={(this.state.parsedResult) ? "75vw" : "30vw"}>
        <ModalHeader closeButton>
          {this.props.title}
        </ModalHeader>
        <ModalBody>
        <Row><Col>Filename  : {(this.state.csvFileName) ? this.state.csvFileName: "Select File"}</Col></Row>
        <Row>&nbsp;</Row>
          <Row>
            <Col>
                <Button id="import-button" colorScheme='blue' mr={3}>
              <input type="file" id="files" style={{ display: "none" }} accept="application/csv" multiple="false" onChange={(e) => this.onFileImportRequest(e)}></input>
              <label classname={"icon-circle"} for="files"><FontAwesomeIcon id="fileMode" icon={faFileImport} />~Get File</label>
            </Button>
         
            </Col>
          </Row>


        {(this.state.parsedResult) &&
        <TableContainer>
          <Table>
            <Thead>
              <Tr>
                {this.state.parsedResult.meta.fields.map((h) => <Th>{h}</Th>)}
              </Tr>
            </Thead>
            <Tbody>
              {this.state.parsedResult.data.map(item => 
                <Tr>
                  {Object.keys(item).map(col => <Td>{item[col]}</Td>)}
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        }

        {(this.state.parsedResult?.errors) && (this.state.parsedResult.errors.length>0) && 
        <TableContainer>
          <Table>
            <Thead>
              <Tr>
              <Th color={"red"}>Errors</Th>
              </Tr>
            </Thead>
            <Tbody>
              {this.state.parsedResult.errors.map(item => 
                <Tr>
                  {Object.keys(item).map(col => {
                    return <Td style={{color:"red"}}>Row {item.row} : {item.message}</Td>
                  })}
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        }        


          <Row style={{color: "red", fontSize: "11px"}}>{this.state.errMsg}</Row>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme='blue' mr={3}
            disabled={((!this.state?.parsedResult) || (this.state.hasImportErrors))}
            onClick={(e) => this.onOkButtonClick(e)}
          >
            Ok
          </Button>
          <Button
            colorScheme='blue' mr={3}
            onClick={(e) => this.onCloseRequest(e)}
          >
            Cancel
          </Button>
          <div>
            {savingDiv}
          </div>
        </ModalFooter>
        </ModalContent>
      </Modal>
      : <span/>
    );
  }
}
